<h1 mat-dialog-title>Renta actual</h1>
<div mat-dialog-content>

</div>
